<oui-menu [menuItems]="menuItems">
  <oui-button type="icon" color="secondary"><oui-icon>more_vert</oui-icon></oui-button>
</oui-menu>
